import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { NgxMaskModule } from 'ngx-mask';

import { InputErrorModule } from '@app/modules/ui-components/components/input-error/input-error.module';
import { TooltipHelpComponent } from '@shared/components/tooltip-help/tooltip-help.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TooltipDirectiveModule } from '@shared/directives/tooltip.directive';
import { PipesModule } from '@shared/pipes/pipes.module';
import { IconComponent } from '@ui-components/components/icon/icon.component';

import { InputFileComponent } from './input-file.component';

@NgModule({
  declarations: [InputFileComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    NgxMaskModule,
    IconComponent,
    InputErrorModule,
    MatButtonModule,
    PipesModule,
    TooltipDirectiveModule,
    DirectivesModule,
    TooltipHelpComponent,
  ],
  exports: [InputFileComponent],
})
export class InputFileModule {}
